<template>
    <div>
        <top-bar class="topbar"></top-bar>
	    <div class="otp-page-wrapper">
		    <div class="wrapper-body-otp"
		    		v-if="objOTPError && !objOTPError.isShowError">

		    	<div class="otp-headline">{{ lbl.otp.headline }}</div>
		    	<div class="otp-info">
		    		<div class="otp-txt" v-html="lbl.otp.line1"></div>
		    		<div class="otp-txt">{{ lbl.otp.line2 }}</div>
		        </div>
                <div class="otp-input">

		        	<input type="tel"
		        		v-if="objOTP"
		        		v-model="objOTP.otp"
		        		maxlength="6"
		        		@input="onChange()"/>
                </div>
                <div class="otp-error">

			        <div class="otp-error-txt"
			        	v-if="objOTPTimer && !objOTPTimer.isTimeExpired">
			        	{{ lbl.otp.time_left1 }} {{ objOTPTimer.time_left }} นาที
			        </div>
                </div>

                <div class="otp-resend">
			        <div class="otp-resend-txt"
			        	v-if="objOTP && objOTP.isShowResendOTP"
			        	@click="resendOtp()">{{ lbl.otp.resend_line2 }}
			        </div>
                </div>
                <div class="otp-submit">
                    <div class="btn-submit" @click="submitOtp()">ยืนยัน</div>
                </div>
            </div>
	        <div class="wrapper-body-otp error"
                v-if="objOTPError && objOTPError.isShowError">

                <div class="error-info">
                    <div class="error-headline">{{ lbl.otp.headline_error }}</div>
                    <div class="error-message"
                        v-if="objOTPError"
                        v-html="objOTPError.strMessage">
		        	</div>
                    <div class="error-submit" v-show="!isSendAgain">
                      	<div class="btn-error" @click="againOtp()">
                        	{{ lbl.otp.again }}
                      	</div>
                    </div>
                    <div class="error-submit" v-show="isSendAgain">
                      	<div class="btn-error" @click="againRegister()">
                        	{{ lbl.otp.newregis }}
                      	</div>
                    </div>
                </div>
            </div>
        </div>

	    <modal-success-with-link
          :busModal="busModalSuccessWithLink">
        </modal-success-with-link>

        <modal-success-page :busModal="busModalSuccessPage"></modal-success-page>

        <modal view="otp" :busModal="busModal"
                @modalAlertOk="modalAlertOk"></modal>

    </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";
import Moment from "moment";
import OtpModel from "@/model/OtpModel.js";
import Otp from "@/helper/OtpHelper.js";
import Modal from "@/components/modal/Modal.vue";

import Register from "@/helper/RegisterHelper.js";
import Account from "@/helper/AccountHelper.js";
import TopBar from "@/components/TopBar.vue";

import ModalSuccessWithLink from "@/components/register/ModalSuccessWithLink.vue";
import ModalSuccessPage from "@/components/register/ModalSuccessPage.vue";
import { TrackingService } from "@/helper/TrackingHelper.js";


import CacheHelper from "@/helper/CacheHelper.js";
import RecaptchaFunction from '@/helper/facade/RecaptchaFunction';

/**
 * Property
 * @property {object} lbl (required) Text for component.
 * @property {object} busOtpModal (required) Modal Controller.
 * Method
 * @method initialOtpModal Setup otp modal with campaign.
 * @method closeOtpModal Stop interval and close modal.
 * Interval
 * @method startInterval Start otp interval.
 * @method stopInterval Stop otp interval.
 * @method otpTimeExpired Set otp modal to expired state.
 * @method runOTPInterval Setup time information and start interval.
 * @method timeFormatter Format timestamp to count down timer.
 */

export default {
  name: "OtpModal",
  components: {
    Modal,
	TopBar,
	ModalSuccessWithLink,
    ModalSuccessPage,

  },
  props: {
    lbl: Object,
    busOtpModal: Object,
  },
  data: function () {
    return {
		objOTP: null,
		objOTPTimer: null,
		objOTPError: null,
		interval: null,
		objauthRequestOTPConfig: {},
		isRequestOTPBtnEnable: false,
		isSendOTPBtnEnable: false,
		numOTPTime: 180,
		busModal: new Vue(),
      	isSendAgain: false,

		registerdata: "",
		registerModel: {
			nameTH: "",
			surnameTH: "",
			nameEN: "",
			surnameEN: "",
			contact_number: "",
			otp: "",
			refcode: "",
			boutiqueId: "",
			sourceId: "",
			countryCode: "",
		},
		registerHelper: new Register(),
      	busModalSuccessWithLink: new Vue(),
      	busModalSuccessPage: new Vue(),
        tracking: new TrackingService(this),
        recaptchaFunction: new RecaptchaFunction(),
    };
  },
    created: function() {



    },
  mounted: function () {
	this.busOtpModal.$on("showOtpModal", this.initialOtpModal);
    this.busOtpModal.$on("hideOtpModal", this.closeOtpModal);
    this.busOtpModal.$on("showErrorOtpModal", this.showError);

    console.log("asdasd", this.$configModalNoConnect);


    setTimeout(() => {
      window.scrollTo(0, 0);
      //document.getElementByClassName("totop-div").scrollTop = 0
    }, 500);
  },
  methods: {
    getRecapchaKey: function () {

        let siteKey = Vue.bzbsConfig.siteKey

        return new Promise((resolve) => {
            this.recaptchaFunction.ready(() => {
                this.recaptchaFunction.execute(siteKey, {action: 'otp'}).then(function(token) {
                    // Add your logic to submit to your backend server here.
                    console.log('recaptcha-submit', token);
                    resolve(token)
                });
            })
        });


    },
    initialOtpModal: async function (registerdata) {
        let key = await this.getRecapchaKey();
        this.$nextTick(() => {
			window.scrollTo(0, 0);
		});
        this.objauthRequestOTPConfig = registerdata.otpdata;
        this.registerdata = registerdata.information.data.registerModel;
        this.birthdateVal = registerdata.birthdate;

        this.objOTP = new OtpModel.OTPModelBuilder().create();
        this.objOTPError = new OtpModel.OTPErrorModelBuilder().create();
        this.objOTPTimer = new OtpModel.OTPTimerModelBuilder().create();
        this.busModal.$emit("showLoadingModal");

        Otp.requestOTP(this.objOTP, this.objauthRequestOTPConfig, key)
            .then((objResult) => {
                this.busModal.$emit("hideLoadingModal");
                Util.log(objResult);
                this.isSendOTPBtnEnable = false;
                this.runOTPInterval(objResult.expireTime);
                //this.$bvModal.show("otp_modal");
            })
            .catch((error) => {
                this.busModal.$emit("hideLoadingModal");
                this.otpTimeExpired();
                if (error.response) {
                    this.showError(error);
                    //this.$bvModal.show("otp_modal");
                } else {
                    this.showErrorInternet();
                    //this.busModal.$emit("showAlertModal", this.$configModalNoConnect);
                }
            });
    },
    modalAlertOk: function (event) {

        if (event.tag == "tokenError") {
            window.location.replace('/landing/line');
        }
    },
    submitOtp: function () {
        this.tracking.event("regis_otp", "click_confirm_otp");

        this.$nextTick(() => {
			window.scrollTo(0, 0);
		});
    	// this.registerModel.refcode = this.objOTP.refcode;
		// this.registerModel.otp = this.objOTP.otp;
		this.registerdata.otp = this.objOTP.otp;
		this.registerdata.refcode = this.objOTP.refcode;

        var token = Account.getToken();

        var date = new Date();
        var datenow = Moment(date).format("DD/MM/YYYY HH:mm");

        if (!token) {

            var configModal = {
                title: null,
                message: "พบข้อผิดพลาด ลองใหม่อีกครั้ง </br>" + datenow,
                strBtnOk: "ปิด",
                tag: "tokenError",
            };
            this.busModal.$emit('showAlertModal', configModal);

            return;
        }
        var boutiqueId = Account.getCacheCustom("boutiqueId");

        if (boutiqueId) {
		    //this.registerModel.boutiqueId = boutiqueId;
            try {

                this.registerdata.boutiqueId = JSON.parse(boutiqueId);
            } catch (error) {
                this.registerdata.boutiqueId = boutiqueId;
            }
    	}

        var cacheLocal = new CacheHelper('local');
        //var boutiqueId = Account.getCacheCustom("boutiqueId");
        var localBoutiqueId = cacheLocal.getCache("boutiqueId");
    	if (localBoutiqueId) {
		    //this.registerModel.boutiqueId = boutiqueId;
		    this.registerdata.localboutiqueId = localBoutiqueId;
    	}

        var refkey = cacheLocal.getCache("refKey");
        if (refkey) {
            this.registerdata.refkey = refkey;
        }


    	var sourceId = Account.getCacheCustom("sourceId");
    	if (sourceId) {
            //this.registerModel.sourceId = sourceId;
            this.registerdata.sourceId = sourceId;
    	}
    	if (this.birthdateVal && this.birthdateVal != "") {
            this.registerdata.birthdate = this.birthdateVal;
    	    // var birthdateStr = this.birthdateVal
    	    // // .toLocaleDateString("en-GB")
    	    // // .split("/");
            // //   this.registerModel.birthdate =
            // //     birthdateStr[2] + "-" + birthdateStr[1] + "-" + birthdateStr[0];
            // this.registerdata.birthdate =
            //     birthdateStr[2] + "-" + birthdateStr[1] + "-" + birthdateStr[0];
            }

            var param = Util.normalObject(this.registerdata);
            this.busModal.$emit("showLoadingModal");
            this.registerHelper
            .sendRegister(token, param)
            .then((objResult) => {
                this.busModal.$emit("hideLoadingModal");
                Util.log(objResult);
                Account.apiGetProfile();

                this.busOtpModal.$emit("hideOtpModal", {});

                var target_page = Account.getCacheCustom("target_page");
                var campaignid = Account.getCacheCustom("campaignId");
                var campaignType = Account.getCacheCustom("campaignType");
                // clear cache success register

                // var target_page = JSON.parse(Account.getCacheCustom("target_page"));
                // var campaignid = JSON.parse(Account.getCacheCustom("campaignId"));
                // var campaignType = JSON.parse(Account.getCacheCustom("campaignType"));

                Account.removeCacheCustom("target_page");
                Account.removeCacheCustom("campaignId");
                Account.removeCacheCustom("campaignType");


    	        if (target_page == "campaign") {
                    ///landing/line?liff.state=target_page=campaign&campaignid=91677
                    //"/landing/line?liff.state=%3FboutiqueId%3Dxxxx%26sourceId%3Dyyyy%26target_page%3Dcampaign%26campaignid%3D549070&state=line_authorize"
                    var paramstr = "?3FboutiqueId=xxxx&target_page=" + target_page + "&campaignid=" + campaignid;
                    //Account.removeCacheCustom("campaignId");
                    // paramstr = encodeURIComponent(paramstr);
                    //  window.location.href = "/landing/line?liff.state=" + paramstr;
                    if (campaignType == Vue.CampaignType.Free) {
                        this.busModalSuccessPage.$emit("showModal", {
                        type: "ticket",
                        paramStr: paramstr,
                        });
                    } else if (campaignType == Vue.CampaignType.Deal) {
                        this.busModalSuccessPage.$emit("showModal", {
                        type: "campaign",
                        paramStr: paramstr,
                        });
                    } else {
                        this.busModalSuccessWithLink.$emit("showModal");
                    }
                } else {
                    this.busModalSuccessWithLink.$emit("showModal");
                }
    	    })
    	    .catch((error) => {
    	    this.busModal.$emit("hideLoadingModal");
                if (error && error.response){

                    this.showError(error);
                }
    	    else {
			    this.busModal.$emit("showAlertModal", this.$configModalNoConnect);
			}
    	});
    },
    resendOtp: async function () {
        let key = await this.getRecapchaKey();
        this.busModal.$emit("showLoadingModal");
        this.objOTP.isShowResendOTP = false;
        Otp.requestOTP(this.objOTP, this.objauthRequestOTPConfig, key)
        .then((objResult) => {
            this.busModal.$emit("hideLoadingModal");
            Util.log(objResult);
            this.isSendOTPBtnEnable = false;
            this.runOTPInterval(objResult.expireTime);
        })
        .catch((error) => {
            if (error.response) {
                this.busModal.$emit("hideLoadingModal");
                this.showError(error);

            } else {
                this.showErrorInternet();
            }

        });
    },
    showError: function (objError) {
        if (objError && objError.response.data && objError.response.data.error) {
            this.objOTP.otp = "";
            if (objError.response.data.error.code == 409 && objError.response.data.error.id == 2091) {
                this.objOTPError.strMessage = this.lbl.otp.invalid_otp_error;
                this.objOTPError.isShowError = true;
            } else if (objError.response.data.error.id == 2092) {
                this.isSendAgain = true;
                this.objOTPError.strMessage = this.lbl.otp.otp_expire;
                this.objOTPError.isShowError = true;
            } else if ( objError.response.data.error.message == "Exceed registration time") {
                this.isSendAgain = true;
                this.objOTPError.strMessage = this.lbl.otp.register_time;
                this.objOTPError.isShowError = true;
            } else if (objError.response.data.error.message == "Exceed OTP fail limit") {

                this.isSendAgain = true;
                this.objOTPError.strMessage = this.lbl.otp.register_limit;
                this.objOTPError.isShowError = true;
            } else {
                this.objOTPError.strMessage = objError.response.data.error.message;
                this.objOTPError.isShowError = true;
            }
        } else {
          this.objOTPError.strMessage = this.lbl.otp.msg_error;
          this.objOTPError.isShowError = true;
        }
    },
    showErrorInternet: function () {
        var configModal = {
            title: null,
            message: "พบปัญหาการเชื่อมต่อ",
            strBtnOk: "ปิด",
            tag: "nointernet",
        };
        this.busModal.$emit('showAlertModal', configModal);
    },
    authStart: function () {
        var token = Account.getToken();
        this.registerHelper.authStart(token).catch((error) => {
          this.busModal.$emit("hideLoadingModal");
          this.busModal.$emit("showAlertModal", error);
        });
    },
    againRegister: function () {
        this.$bvModal.hide("otp_modal");
        this.authStart();
        if (this.objOTPError.strMessage == this.lbl.otp.register_time) {
             this.tracking.event("regis_otp_error", "click_exceed_attempt_otp");
        } else {
            this.tracking.event("regis_otp_error", "click_exceed_time_limit_otp");
        }

        this.isSendAgain = false;
        var objRegisterconfig = {
            // birthdate: this.birthdateVal,
            // registerModel: this.registerModel,
            // contac_number: this.registerModel.contact_number,
            tag: 'register_form',
        }

        this.$emit('onClicknext', objRegisterconfig);
        // this.isSendAgain = false;
    },
    againOtp: function () {
        this.tracking.event("regis_otp_error", "click_wrong_otp");
        this.resendOtp();
        this.objOTPError = new OtpModel.OTPErrorModelBuilder().create();
    },
    closeOtpModal: function () {
        this.stopInterval();
        this.$bvModal.hide("otp_modal");
    },
    runOTPInterval: function (numExpireIn) {
        this.objOTP.isShowResendOTP = false;
        this.objOTPTimer = Otp.SetRunOTPTimer(numExpireIn);
        console.log(this.objOTPTimer);
        this.startInterval();
    },
    startInterval: function () {
        this.stopInterval();
        var self = this;
        this.timeFormatter(false, false, ":");
        this.interval = setInterval(function () {
            self.timeFormatter(false, false, ":");
        }, 1000);
    },
    stopInterval: function () {
        clearInterval(this.interval);
    },
    otpTimeExpired: function () {
        this.isSendOTPBtnEnable = false;

        this.objOTP.isShowResendOTP = true;
        this.objOTPTimer.isTimeExpired = true;

        this.stopInterval();
    },
    timeFormatter: function (isShowDay, isShowHour, strSeparator) {
        var numTimeDiff =
            Moment.unix(this.objOTPTimer.numExpireDate) -
            Moment.unix(this.objOTPTimer.numCurrentDate);
        //Timer Expired
        if (numTimeDiff <= 0) {
            numTimeDiff = 0;
            this.otpTimeExpired();
        }

        //Add 1 second to current date.
        this.objOTPTimer.numCurrentDate++;

        //Calculate day.
        var numDayDiff = Math.floor(numTimeDiff / 1000 / 60 / 60 / 24);
        var haveDay = parseInt(numDayDiff) <= 0 ? false : true;
        if (isShowDay) numTimeDiff -= numDayDiff * 1000 * 60 * 60 * 24;

        //Calculate hour.
        var numHourDiff = Math.floor(numTimeDiff / 1000 / 60 / 60);
        var haveHour = parseInt(numHourDiff) <= 0 ? false : true;
        if (isShowHour) numTimeDiff -= numHourDiff * 1000 * 60 * 60;

        if (numHourDiff <= 9) numHourDiff = "0" + numHourDiff;

        //Calculate minute.
        var numMinuteDiff = Math.floor(numTimeDiff / 1000 / 60);
        var haveMinute = parseInt(numMinuteDiff) <= 0 ? false : true;
        numTimeDiff -= numMinuteDiff * 1000 * 60;

        if (numMinuteDiff <= 9) numMinuteDiff = "0" + numMinuteDiff;

        //Calculate second.
        var numSecondDiff = "" + Math.floor(numTimeDiff / 1000);
        var haveSecond = parseInt(numSecondDiff) <= 0 ? false : true;
        if (numSecondDiff <= 9) numSecondDiff = "0" + numSecondDiff;

        var strTimeLeft = "";
        if (isShowDay) {
            if (haveDay) strTimeLeft += numDayDiff + strSeparator;
            else strTimeLeft += "00" + strSeparator;
        }

        if (isShowHour) {
            if (haveHour) strTimeLeft += numHourDiff + strSeparator;
            else strTimeLeft += "00" + strSeparator;
        }

        //Always show minute.
        if (haveMinute) strTimeLeft += numMinuteDiff + strSeparator;
        else strTimeLeft += "00" + strSeparator;

        //Always show second.
        if (haveSecond) strTimeLeft += numSecondDiff;
        else strTimeLeft += "00";

        this.objOTPTimer.time_left = strTimeLeft;
        },
        onChange: function () {
          this.objOTP.otp = this.objOTP.otp.replace(Vue.RegExp.emoji, "");
          this.objOTP.otp = this.objOTP.otp.replace(/[^0-9]/g, "");
        },
    },
};
</script>
<style lang="scss">
    @import "OtpComponent.scss";
    // @import "@/style/base/component/modal/otp.scss";
</style>
